import { IEntityWithStatus, EntityWithStatus } from "./EntityWithStatus";
import { IUserRole } from "./UserRole";
import { IUserGroup } from "./UserGroup";
import { IUserDirectorate } from "./UserDirectorate";
import { IUserProject } from "./UserProject";
import { IDirectorate } from "./Directorate";
import { IProject } from "./Project";
import { IRisk } from "./Risk";
import { IUserPartnerOrganisation } from "./UserPartnerOrganisation";
import { IPartnerOrganisation } from "./PartnerOrganisation";
import { IContributor } from "./Contributor";
import { IFinancialRisk } from "./FinancialRisk";
import { IOrgLevel1 } from "./OrgLevel1";
import { IOrgLevel3 } from "./OrgLevel3";
import { IZCoreUserGroupMember } from "./ZCoreUserGroupMember";

export interface IUser extends IEntityWithStatus {
    CustomerID?: number;
    Username: string;
    EmailAddress: string;
    UserTitle?: string;
    Firstname?: string;
    Surname?: string;
    Phone?: string;
    IsServiceAccount?: boolean;
    AuthenticationTypeID: number;
    Password?: string;
    PasswordActionID?: number;
    UserType?: string;
    JobRole?: string;
    UserRoles?: IUserRole[];
    UserGroups?: IUserGroup[];
    UserDirectorates?: IUserDirectorate[];
    UserPartnerOrganisations?: IUserPartnerOrganisation[];
    UserProjects?: IUserProject[];
    DirectorateDirectorUsers?: IDirectorate[];
    OrgLevel1DirectorGeneralUsers?: IOrgLevel1[];
    OrgLevel3DeputyDirectorUsers?: IOrgLevel3[];
    ProjectSeniorResponsibleOwnerUsers?: IProject[];
    CorporateRiskRiskOwnerUsers?: IRisk[];
    CorporateRiskReportApproverUsers?: IRisk[];
    FinancialRiskRiskOwnerUsers?: IFinancialRisk[];
    FinancialRiskReportApproverUsers?: IFinancialRisk[];
    DirectorateReportApproverUsers?: IDirectorate[];
    ProjectReportApproverUsers?: IProject[];
    PartnerOrganisationLeadPolicySponsorUsers?: IPartnerOrganisation[];
    PartnerOrganisationReportAuthorUsers?: IPartnerOrganisation[];
    ContributorContributorUsers?: IContributor[];
    FinancialRiskUserGroups?: IUserGroup[];
    ZCoreUserGroupMembers?: IZCoreUserGroupMember[];
}

export class User extends EntityWithStatus implements IUser {
    public Username = '';
    public EmailAddress = '';
    public UserTitle = null;
    public Firstname = null;
    public Surname = null;
    public Phone = null;
    public IsServiceAccount = false;
    public AuthenticationTypeID = null;
    public Password = null;
    public PasswordActionID = 1; //default
    public UserType = null;
    public JobRole = null;
}